document.addEventListener('DOMContentLoaded', function () {
  let totalPoints = 0;
  let currentPoints = 0;


  // helper functions
  function qs(selector) {
    return document.querySelector(selector);
  }

  function qsa(selector) {
    return document.querySelectorAll(selector);
  }

  function hideElements(elements) {
    elements.forEach(el => el.style.display = 'none');
  }

  function showElement(el) {
    el.style.display = 'block';
  }

  function activateStep(index) {
    const step = qs(`.stepCircle[data-index='${index}']`);
    const stepContent = qs(`.stepContent[data-index='${index}']`);

    if (step) step.classList.add('active');
    if (stepContent) stepContent.classList.add('active');

    qsa('.stepContent').forEach(el => {
      if (el !== stepContent) el.classList.remove('active');
    });
  }

  // Take quiz
  qsa('.takeQuizBtn').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      activateStep(2);
      this.style.display = 'none';
    });
  });

  // Stop
  qsa('.answerStop').forEach(btn => {
    btn.addEventListener('click', function () {
      hideElements(qsa('.stepCircles'));
      const step0Content = qs(".stepContent[data-index='0']");
      step0Content.classList.add('active');

      qsa('.stepContent').forEach(el => {
        if (el !== step0Content) el.classList.remove('active');
      });
    });
  });

  // Continue
  qsa('.answerContinue').forEach(btn => {
    btn.addEventListener('click', function () {
      activateStep(3);
    });
  });

  // Step answers (3 → 15)
  for (let i = 3; i <= 14; i++) {
    qsa(`.stepContent[data-index='${i}'] .answer`).forEach(answer => {
      answer.addEventListener('click', function () {
        const points = parseInt(this.dataset.points, 10);
        totalPoints += points;
        currentPoints = points;
        activateStep(i + 1);
      });
    });
  }

  // Final step (15)
  qsa(".stepContent[data-index='15'] .answer").forEach(answer => {
    answer.addEventListener('click', function () {
      totalPoints += parseInt(this.dataset.points, 10);
      console.log(totalPoints);

      hideElements(qsa("h1.headingPage.pageHeading, .rte"));

      hideElements(qsa('.stepContent'));
      hideElements(qsa('.stepCircle'));

      let productClass;

      if (totalPoints < 2) {
        productClass = 'quizProduct0';
      } else if (totalPoints <= 3) {
        productClass = 'quizProduct1';
      } else if (totalPoints <= 6) {
        productClass = 'quizProduct2';
      } else if (totalPoints <= 11) {
        productClass = 'quizProduct3';
      } else {
        productClass = 'quizProduct4';
      }

      qsa('.quizProduct').forEach(p => p.style.display = 'none');
      showElement(qs(`.${productClass}`));
    });
  });

});
